import 'css-chunksrc/client/pages/occupancyPage/table/projectsDetail/projectRow/styles.scss';export default {
  "row": "_row_9w86i_1",
  "projectCell": "_projectCell_9w86i_6",
  "zone": "_zone_9w86i_22",
  "icon": "_icon_9w86i_29",
  "name": "_name_9w86i_36",
  "clickable": "_clickable_9w86i_44"
};